import React from 'react';
import {injectStripe} from 'react-stripe-elements';
import {CardElement} from 'react-stripe-elements';
import {StyledButton, InlineError} from '../Typeset';
import Button from "@material-ui/core/Button";
import {Paper} from "@material-ui/core";
import {P, H4} from "../Typeset"


class CheckoutForm extends React.Component {
  state = {
    error: ''
  };

  handleSubmit = (ev) => {
    ev.preventDefault();
    this.setState({error: ''});
    this.props.onSubmit();
    this.props.stripe.handleCardPayment(
      this.props.clientIntentClientSecret,
    ).then((response) => {
      if (response.error) {
        this.setState({error: response.error.message});
        this.props.onFailure();
      } else if (response.paymentIntent && response.paymentIntent.status === 'succeeded') {
        this.props.onSuccess({paymentId: response.paymentIntent.id});
      }
    });
  };

  render() {
    return (
      <Paper elevation={3} style={{
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: '#54565f',
        width: 360,
        padding: '10px 24px 24px',
        outline: 'none'
      }}>
        <form onSubmit={this.handleSubmit}>
          <div style={{
            marginBottom: 20,
            color: 'rgba(255, 255, 255, 0.85)'
          }}>
            <H4 style={{marginBottom: 30}}>CONFIRM NAME CHANGE</H4>
            <P>
              <div style={{fontSize: '0.8rem'}}>Ticket</div>
              <b>{this.props.nameChangeTicketDescription}</b>
              <br/>
              <br/>
              <span style={{width: 55, display: 'inline-block'}}>From:</span> {this.props.fromName}
              <br/>
              <span style={{width: 55, display: 'inline-block'}}>To:</span> {this.props.toName}
            </P>
            <div style={{
              fontSize: '0.8rem',
              marginBottom: 6
            }}>Card details:</div>
            <CardElement hidePostalCode style={{
              base: {
                fontSize: '14px',
                fontFamily: 'Montserrat, Roboto, "Helvetica Neue", Arial',
                fontSmoothing: 'antialiased'
              },
              invalid: {
                color: '#9e2146',
              },
            }} />
          </div>
          {this.state.error && <InlineError>{this.state.error}</InlineError>}
          <div style={{display: 'flex'}}>
            <Button style={{color: 'white', marginRight: 16}} size="small" onClick={this.props.onCancel}>
              Cancel
            </Button>
            <StyledButton type="submit">Pay {this.props.priceStr}</StyledButton>
          </div>
        </form>
      </Paper>
    );
  }
}

export default injectStripe(CheckoutForm);
